import apollo from 'apollo';
import { AsyncActionHandler } from 'action-handler';
import { appPermissionMutate } from 'queries';
import { savePermissions } from 'actions/gallery';

const STATE_PROP = 'grantedPermissions';

export const permissionsFromRegistry = (permissions = []) =>
  permissions.reduce((permissions, { name, granted }) => {
    permissions[name] = granted;
    return permissions;
  }, {});

export const permissionsToRegistry = (permissions) =>
  Object.keys(permissions).map((name) => ({
    name,
    granted: permissions[name]
  }));

export const multiReducer = (state, { entries = [] }) => {
  const permissions = entries.reduce(
    (allPermissions, { appId, permissions }) => {
      allPermissions[appId] = permissionsFromRegistry(permissions);
      return allPermissions;
    },
    {}
  );

  return {
    [STATE_PROP]: permissions
  };
};

export const reducer = (state, { appId, permissions }) => ({
  [STATE_PROP]: {
    ...state[STATE_PROP],
    [appId]: permissionsFromRegistry(permissions)
  }
});

export default new AsyncActionHandler({
  name: 'update_permissions',
  stateProp: STATE_PROP,
  defaultState: {
    [STATE_PROP]: {}
  },
  handler: (id) => async (dispatch, getState) => {
    const {
      grantedPermissions: { [id]: grantedPermissions }
    } = getState().gallery;
    let permissions;
    if (grantedPermissions) {
      permissions = permissionsToRegistry(grantedPermissions);
    }

    const {
      data: { setAppPermissions }
    } = await apollo.mutate({
      mutation: appPermissionMutate,
      variables: {
        id,
        permissions
      }
    });

    // Clear client permissions for app since they are persisted
    // on the server now
    dispatch(savePermissions({ appId: id, grantedPermissions: {} }));

    return {
      entries: setAppPermissions
    };
  },
  reduce: multiReducer
});
